import { useQuery } from "@tanstack/react-query";
import { useRecoilValue } from "recoil";
import { InterphoneAreaType } from "../../controller/InterphoneController";
import ApiController from "../../controller/ApiController";
import { masterStoreState } from "../../recoil/auth";
import { langState } from "../../recoil/lang";

export const useInterphoneListQuery = () => {
  const masterStore = useRecoilValue(masterStoreState);
  const lang = useRecoilValue(langState);

  // 통화 가능 장소 목록
  const { data: interphoneArea } = useQuery<InterphoneAreaType[]>({
    queryKey: ["interphone-area"],
    queryFn: () =>
      ApiController.interphone
        .callAvailableHotelArea({
          hotel_id: masterStore!.store_id,
          lang: lang,
        })
        .then((res) => res.data.data.hotelAreaData || []),
    enabled: !!masterStore && !!masterStore.store_id,
  });

  return {
    interphoneArea,
  };
};
